import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/esm/slicedToArray";
import React, { useState } from 'react';
import { Form } from 'react-bootstrap';
import { ErrorMessage } from 'formik';
import { IoIosCloseCircle } from 'react-icons/io';
import { uniqueId } from 'lodash'; // Import uniqueId function from lodash

var OrderNumberField = function OrderNumberField(props) {
  var _useState = useState(typeof props.value !== 'undefined' && props.value !== ''),
      _useState2 = _slicedToArray(_useState, 2),
      active = _useState2[0],
      setActive = _useState2[1];

  var _useState3 = useState(props.value || ''),
      _useState4 = _slicedToArray(_useState3, 2),
      value = _useState4[0],
      setValue = _useState4[1];

  var id = uniqueId();

  var handleFocus = function handleFocus() {
    setActive(true);
  };

  var handleBlur = function handleBlur() {
    setActive(false);
  };

  var onChange = function onChange(e) {
    var newValue = e.currentTarget.value.replace(/\D/g, '');
    setValue(newValue);
    props.form.setFieldValue(e.currentTarget.name, newValue);
    props.changeHandler(newValue);
  };

  var _props$field = props.field,
      name = _props$field.name,
      field = _objectWithoutProperties(_props$field, ["name"]);

  var errors = props.form.errors;
  var touched = props.form.touched;
  var Tag = Form.Control;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Form.Group, {
    controlId: "".concat(props.field.name, "-").concat(id),
    onBlur: handleBlur
  }, /*#__PURE__*/React.createElement(Form.Label, {
    className: "\n            cb-form__label\n            ".concat(active || (field === null || field === void 0 ? void 0 : field.value) !== '' ? 'is-active' : '', "\n            ").concat(props.type === 'date' ? 'is-date' : '', "\n            ").concat(props.type === 'datetime-local' ? 'is-date' : '', "\n            ").concat(typeof field.value !== 'undefined' && field.value !== '' ? 'is-filled' : '', "\n          ")
  }, props.label || name), /*#__PURE__*/React.createElement(Tag, {
    className: "\n              cb-form__input\n              form-control\n              ".concat(props.className, "\n              ").concat(active ? 'is-active' : '', "\n              ").concat(typeof field.value !== 'undefined' && field.value !== '' ? 'is-filled' : '', "\n              ").concat(errors[props.field.name] && touched[props.field.name] ? 'is-error' : '', "\n            "),
    name: props.field.name,
    type: "text",
    maxLength: props.maxLength,
    placeholder: props.placeholder,
    disabled: props.disabled,
    autoComplete: props.autocomplete,
    onChange: onChange,
    onBlur: field.onBlur,
    onFocus: handleFocus,
    onError: field.handleError,
    mask: null,
    value: props.value
  }), /*#__PURE__*/React.createElement(ErrorMessage, {
    name: name
  }, function (msg) {
    return /*#__PURE__*/React.createElement("div", {
      className: "cb-form__error-message"
    }, /*#__PURE__*/React.createElement(IoIosCloseCircle, null), " ", msg);
  }), props.errorMessage && /*#__PURE__*/React.createElement("div", {
    className: "cb-form__error-message"
  }, /*#__PURE__*/React.createElement(IoIosCloseCircle, null), " ", props.errorMessage)));
};

OrderNumberField.defaultProps = {
  type: 'digits',
  value: '',
  className: '',
  placeholder: ''
};
export default OrderNumberField;